import * as React from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import HttpActionsService from '../../../Services/HttpActionsService'
import UserStore from '../../../Stores/UserStore'
import { history } from '../../../Routing'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { getMerchantForm } from '../../../Model/MerchantModel'

export interface IMerchantPageProps {
    httpActionsService: HttpActionsService
    userStore?: UserStore
    localizationStore: LocalizationStore
}

@inject('httpActionsService')
@inject('userStore')
@inject('localizationStore')
@observer
class MerchantPage extends React.Component<IMerchantPageProps> {
    constructor(props: any) {
        super(props)

        if (!UserStore.getInstance().checkSession) {
            history.push('/login')
        }
        this.props.httpActionsService!.getMerchant(this.props['match']!['params']['id'])
    }

    render() {
        const { localizationStore } = this.props
        return (
            <div className="merchantPage row">
                <div className="col-12">
                    <h4>{localizationStore!.t('MerchantPageHeader')}</h4>
                </div>
                <div className="col-12">
                    {getMerchantForm()}
                </div>
            </div>
        )
    }
}

export default withRouter(MerchantPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Merchant/MerchantPage.tsx